import { LogoSpinner } from "@/components/ui/logo-spinner";

/**
 * Voile de chargement plein écran : le logo vient DEVANT la page, centré, et
 * l'arrière-plan reste visible en transparence — on ne quitte pas la page.
 *
 * Conserve le nom historique : appelé 6× (ProtectedRoute ×4, routes/index.tsx,
 * FindCourtPage). N'embarque plus de Lottie — voir `logo-spinner.tsx`.
 */
export const LottieSpinner = () => (
  <div
    aria-busy="true"
    className="fixed inset-0 z-50 flex items-center justify-center bg-background/70 backdrop-blur-sm"
  >
    {/* La taille suit le layout : 112 px au plus petit, ~230 px sur un écran
        courant, plafonné à 256 px. `vmin` plutôt que `vw` pour que le logo ne
        déborde pas en paysage sur un écran bas. */}
    <LogoSpinner size="clamp(7rem, 26vmin, 16rem)" />
  </div>
);
